import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row no-wrap items-center justify-between q-mt-sm q-col-gutter-x-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_date_picker, {
      class: "col",
      clearable: "",
      label: _ctx.t('FROM'),
      modelValue: _ctx.startDate,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
      "to-limit": _ctx.endDate
    }, null, 8, ["label", "modelValue", "to-limit"]),
    _createVNode(_component_date_picker, {
      class: "col",
      clearable: "",
      label: _ctx.t('TO'),
      modelValue: _ctx.endDate,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDate) = $event)),
      "from-limit": _ctx.startDate
    }, null, 8, ["label", "modelValue", "from-limit"])
  ]))
}